import{throwQueryError}from"./throw.js";


export const validateQueryString=(queryString)=>{
if(!isQueryString(queryString)){
throwQueryError(queryString,"It must be a string.")
}
};



export const isQueryString=(query)=>typeof query==="string";


export const validateEmptyQuery=(queryArrays,queryString)=>{
if(queryArrays.length===0){
throwQueryError(queryString,"It must not be an empty string.")
}
};